// Pages that need a per-project scope go behind this gate. If the
// operator hasn't picked a project yet (fresh sign-up, or their last
// project was archived out from under them), they get bounced to
// /projects to choose. Without this gate, every API hook in the page
// would fail — either a 404 on the nested URL (no IDs to inject) or
// a 412 from the legacy shim.

import { Navigate, Outlet } from "react-router-dom";
import { Spinner, Box } from "@chakra-ui/react";
import { useMe } from "@/hooks/useAuth";

export default function RequireActiveProject() {
  const { data: me, isLoading } = useMe();

  if (isLoading) {
    return (
      <Box p={8}>
        <Spinner size="md" />
      </Box>
    );
  }

  if (!me?.lastActiveProjectId) {
    return <Navigate to="/projects" replace />;
  }

  return <Outlet />;
}
